<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid
    #poslovniImenikGrid
    id="poslovniImenikGrid"
    keyExpr="nazivFirme"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true">
    
    <dxi-column 
      dataField="nazivFirme" 
      caption="Naziv Firme" 
      [minWidth]="200"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="djelatnost" 
      caption="Djelatnost" 
      [minWidth]="150"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="grad" 
      caption="Grad" 
      [width]="120"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="drzava" 
      caption="Država" 
      [width]="120"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="kontaktOsoba" 
      caption="Kontakt Osoba" 
      [minWidth]="150"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="telefon" 
      caption="Telefon" 
      [width]="120"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="artikli" 
      caption="Artikli" 
      [minWidth]="200"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="direktor" 
      caption="Direktor" 
      [minWidth]="150"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxi-column 
      dataField="oblast" 
      caption="Oblast" 
      [minWidth]="150"
      [allowFiltering]="true">
    </dxi-column>
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
  </dx-data-grid>
</div>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>